import { FETCH_ALL_TESTS, CREATE_TEST } from '../constants/actionTypes';
import * as api from '../api/index.js';

export const getTests = () => async (dispatch) => {
  try {
    const { data } = await api.fetchTests();

    dispatch({ type: FETCH_ALL_TESTS, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};

export const createTest = (test) => async (dispatch) => {
  try {
    const { data } = await api.createTest(test);

    dispatch({ type: CREATE_TEST, payload: data });
  } catch (error) {
    console.log(error.message);
  }
};
